<template>
  <Modal
    v-model="_value"
    width="800"
    ok-text="添加"
    cancel-text=""
    @on-ok="onOk"
    @on-visible-change="visibleChange"
    title="添加运输车辆信息分组">
    <Form autoComplete="on" class="card-box login-form">
      <Form-item label="分组名称" required>
        <Input v-model="transportVehicleInfoGroup.name" placeholder="分组名称"></Input>
      </Form-item>
      <Form-item v-if="initValue" label="父级分组" required>
        <Input :readonly="true" v-model="parentGroupName" placeholder="父级分组"></Input>
      </Form-item>
      <Form-item label="备注">
        <Input v-model="transportVehicleInfoGroup.remark" placeholder="备注" type="textarea" style="width: 100%;"></Input>
      </Form-item>
      <Form-item label="描述">
        <Input v-model="transportVehicleInfoGroup.description" placeholder="描述" type="textarea" style="width: 100%;"></Input>
      </Form-item>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'addtransportvehicleinfogroupmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {

      parentGroupName: null,

      transportVehicleInfoGroup: {
        name: null,
        parentGroupId: null,
        remark: null,
        description: null
      }
    }
  },
  methods: {
    ...mapActions([
      'TransportVehicleInfoGroupServ_AddObj'
    ]),
    onOk () {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认添加</p>',
        onOk: () => {
          this.transportVehicleInfoGroup.parentGroupId = this._initValue
          store.dispatch('TransportVehicleInfoGroupServ_AddObj', {
            params: this.transportVehicleInfoGroup
          }).then(() => {
            this.$Message.success('添加成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
          })
        },
        onCancel: () => {

        }
      })
    },
    visibleChange (val) {
      if (val) {
        if (this._initValue) {
          store.dispatch('TransportVehicleInfoGroupServ_GetDetail', {
            params: { id: this._initValue }
          }).then(() => {
            this.parentGroupName = store.getters.get_TransportVehicleInfoGroup_GetDetailResult.name
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
